import { render, staticRenderFns } from "./CorporationsSelect.vue?vue&type=template&id=6d4a8602"
import script from "./CorporationsSelect.vue?vue&type=script&lang=js"
export * from "./CorporationsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports